import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { Form } from 'semantic-ui-react'
import {  Reports } from '../../../api/services/next';
import { GetReservationTotals } from '../../../api/services/pms'
import { useTextResources } from '../../../language'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import { DatePicker } from '../../shared/DatePicker'
import HotelsDropDown from '../../shared/HotelsDropDown'
import moment from 'moment'
import { endpoint } from '../../../api/http'
import { onError } from '../../../components/shared/messages'
import { Currencies } from '../../shared/currencies'
import { dateFormat, DateRange } from '../../shared/constants'
import { useLoader } from '../../../hooks/useLoader';
import { createExcelHeader } from '../../GridPanel/utility';

const GroupReservationsByCheckInDateReport = () => {
    const text = useTextResources()
    const loader = useLoader()
    const [checkInRange, setCheckInRange] = useState([])
    const [checkOutRange, setCheckOutRange] = useState([])
    const [currencySymbol, setCurrencySymbol] = useState()
    const [data, setData] = useState([])


     useEffect(()=>{
         (async ()=>{
            try {
                setCurrencySymbol(getCurrencyByCurrentHotel());
            } catch (error) {
                onError(error)
            }
        })()
     }, [])

     const getCurrencyByCurrentHotel = useCallback(() => {
         const currencyCode = window.optima?.user?.CurrentHotel?.MainCurrencyId;
        return Currencies[currencyCode]?.symbol ?? '';
    })

    const reservationFormatter = ({ value, row }) => {
        if (row) {
            return <a
                target="_blank"
                rel="noopener noreferrer"
                href={`${endpoint}PMS/ReservationGroupDataService/ReservationGroup?groupid=${row.ReservationGroupId}&hotelid=${row.HotelId}`}>
                {value}
            </a>
        } else {
            return value
        }
    }



    const getDateRangeFilter = (rangeName) => {
        switch (rangeName) {
            case DateRange.CheckIn:
                if (!checkInRange || checkInRange.length === 0) return undefined;
                return {
                    FromDate: moment(checkInRange[0]).toISOString(),
                    ToDate: moment(checkInRange[1] || checkInRange[0]).toISOString()
                };
            case DateRange.CheckOut:
                if (!checkOutRange || checkOutRange.length === 0) return undefined;
                return {
                    FromDate: moment(checkOutRange[0]).toISOString(),
                    ToDate: moment(checkOutRange[1] || checkOutRange[0]).toISOString()
                };
            default:
                break;
        }
    }

    const getExportFormatedDate = (rangeName) =>{
        switch (rangeName) {
            case DateRange.CheckIn:
                return checkInRange && `${text("ArrivalDate")}: ${moment(checkInRange[0]).format(dateFormat)} - ${moment(checkInRange[1]).format(dateFormat)}`
            case DateRange.CheckOut:
                return checkOutRange && `${text("DepartureDate")}: ${moment(checkOutRange[0]).format(dateFormat)} - ${moment(checkOutRange[1]).format(dateFormat)}`
            default:
                break;
        }
    }

     const currencyFormatter = ({ value }) => {
        if(value)
            return value && `${value.toFixed(2)} ${currencySymbol}`
        else
            return 0
     }

    const getDateCellValue = (row, columnName) =>{
        const date = row[columnName];
        return date && moment(date).format(dateFormat);
    }

    const agentCompanyFormatter = ({row}) => {
        const agent = row["Agent"];
        const company = row["Company"];
        return `${agent}/${company}`;
    }

    const paxFormatter = ({row}) => {
        const adults = row["TotalAdults"];
        const children = row["TotalChilds"];
        const infants = row["TotalInfants"];
        return `${adults}/${children}/${infants}`;
    }

    const commentsFormatter = ({ value }) => (
        <div dangerouslySetInnerHTML={{ __html: value }} />
      );

    const guestFormatter = ({ value, row }) => {
        return (
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`${endpoint}CRM/GuestProfile/index/?hotelid=${row.HotelId}#/profile/${row.GuestId}`}
          >
            {value}
          </a>
        )
    }

    const excelHeaderTitle = `${text("GroupReservationsByCheckInDate")} - ${getExportFormatedDate(DateRange.CheckIn)}  ${getExportFormatedDate(DateRange.CheckOut)}`;

    const onSearchComplete = async (data, searchState) => {
        //setSearchState(searchState)
        loader(true)

        const blockReservationsIds = data.flatMap(s=> s.Id);
        const childReservationsIds = data.flatMap(s=> s.ReservationIds);
        const allIds = [...blockReservationsIds, ...childReservationsIds];
        const hotelIds = searchState.HotelIds;
        const totals = await GetReservationTotals({ReservationIDs: allIds, HotelIDs: hotelIds});
        if (totals && totals.length) {

            let totalIncome, totalExtraAddons = 0.0;
            let lines, resIds  = [];
            let blockTotals;

            data.forEach(block => {

                totalIncome = 0.0;
                totalExtraAddons = 0.0;

                resIds = block.ReservationIds;
                blockTotals = totals.find(s=> s.ReservationID == block.Id)
                lines = totals.filter(s=> resIds.includes(s.ReservationID))

                totalIncome = lines.reduce((previousValue, currentValue) => {
                    return previousValue
                        + currentValue.TotalAmountDebitAfterTax
                }, 0.0)

                totalExtraAddons = lines.reduce((previousValue, currentValue) => {
                    return previousValue + currentValue.TotalAmountExtraAddonsAfterTax
                }, 0.0)

                block.TotalIncome = blockTotals?.TotalAmountDebitAfterTax + totalIncome;
                block.TotalExtraAddons = blockTotals?.TotalAmountExtraAddonsAfterTax + totalExtraAddons;
            });

        }

        setData(data)
        loader(false)
    }

    const gridOptions = useMemo(() => {
        return {
            search: {
                title: text("GroupReservationsByCheckInDate"),
                fields: [
                    <Form.Field label={text("Hotel")}
                        control={HotelsDropDown}
                        key="HotelIds" clearable width="4"
                        allowSelectAll multiple/>,
                    <DatePicker
                        picktype='range'
                        label={text('ArrivalDate')}
                        key={DateRange.CheckIn}
                        clearable={true}
                        onChange={value => setCheckInRange(value || [])}
                    />,
                    <DatePicker
                        picktype='range'
                        label={text('DepartureDate')}
                        key={DateRange.CheckOut}
                        clearable={true}
                        onChange={value => setCheckOutRange(value || [])}
                    />

                ],
                method: 'POST',
                api: Reports.GroupReservationsByCheckInDateReport,
                initial: {
                    HotelIds: [window?.optima?.user?.CurrentHotel.Id],
                },
                spec: {
                    CheckInDateRange: getDateRangeFilter(DateRange.CheckIn),
                    CheckOutDateRange: getDateRangeFilter(DateRange.CheckOut),
                },
                groupSize: 6
            },
            grid: {
                columns: [
                    {   name: 'Hotel', title: text('Hotel') },
                    {
                        name: 'Number',
                        title: text('Number'),
                        formatter: reservationFormatter,
                    },
                    {
                        name: 'CheckInDate',
                        title: text('ArrivalDate'),
                        getCellValue: getDateCellValue,
                    },
                    {
                        name: 'CheckOutDate',
                        title: text('DepartureDate'),
                        getCellValue: getDateCellValue,
                    },
                    {   name: 'Nights', title: text('Nights') },
                    {   name: 'RoomType', title: text('RoomType') },
                    {   name: 'TotalBlocked', title: text('Blocked') },
                    {   name: 'TotalPicked', title: text('Picked') },
                    {   name: 'Status', title: text('Status') },
                    {   name: 'GuestName', title: text('Contact'), formatter: guestFormatter },
                    {   name: 'GuestPhone', title: text('Phone') },
                    {   name: 'GuestEmail', title: text('Email') },
                    {   name: 'TotalGuests', title: text('TotalGuests') },
                    {   name: 'TotalAdults', title: text('Pax') , formatter: paxFormatter },
                    {   name: 'TotalIncome', title: text('TotalIncome') , formatter: currencyFormatter},
                    {   name: 'ExtraAddons', title: text('ExtraAddons') },
                    {   name: 'Agent', title: text('CompanyOrAgent') , formatter: agentCompanyFormatter},
                    {   name: 'CreatedByUserName', title: text('CreatedByUser') },
                    {   name: 'Comments', title: text('Comments'), formatter: commentsFormatter },
                ],
                summary: true,
                totalSummaryItems: [
                    { columnName: 'Number', type: 'count' },
                    { columnName: 'Nights', type: 'avg' },
                    { columnName: 'Nights', type: 'sum' },
                    { columnName: 'TotalIncome', type: 'sum', formatter: currencyFormatter },
                ],
                export: true,
                pdf: true,
                customOptions: {
                    sort: {
                        sorting: [{ columnName: 'CheckInDate' }]
                    }
                },
                excel: {
                    customizeHeader: createExcelHeader(excelHeaderTitle),
                    totalSummaryItems: [
                        { columnName: 'Number', type: 'count'},
                        { columnName: 'Nights', type: 'avg' },
                        { columnName: 'Nights', type: 'sum' },
                        { columnName: 'TotalIncome', type: 'sum' , formatter: currencyFormatter},
                    ],
                },
                scrollbarX: true
            }
        }
    }, [data, checkInRange, checkOutRange])

    return (<GridSearchTemplate options={gridOptions} onSearchComplete={onSearchComplete} data={data}/>)
}
export default GroupReservationsByCheckInDateReport
